import { fetch as fetchApi } from "../../Component/function/FunctionApi";

/* =========================================================
   GET ALL REPRESENTATIVES
========================================================= */

export const getRepresentatives = async () => {
  const response = await fetchApi(
    "Represntative/get-Represntatives"
  );

  return response;
};

/* =========================================================
   GET REPRESENTATIVE DELIVERY STATS BY NAME
========================================================= */

export const getRepresentativeDeliveryStats = async (name) => {
  const params = new URLSearchParams();

  params.append("name", name);

  const response = await fetchApi(
    `Represntative/delivery-stats-by-name?${params.toString()}`
  );

  return response;
};

/* =========================================================
   GET REPRESENTATIVES BY DELIVERY RANGE
========================================================= */

export const getRepresentativesByDeliveryRange = async ({
  minRate,
  maxRate,
  fromDate,
  toDate,
}) => {
  const params = new URLSearchParams();

  if (
    minRate !== "" &&
    minRate !== null &&
    minRate !== undefined
  ) {
    params.append("MinRate", minRate);
  }

  if (
    maxRate !== "" &&
    maxRate !== null &&
    maxRate !== undefined
  ) {
    params.append("MaxRate", maxRate);
  }

  if (fromDate) {
    params.append(
      "FromDate",
      `${fromDate}T00:00:00`
    );
  }

  if (toDate) {
    params.append(
      "ToDate",
      `${toDate}T23:59:59`
    );
  }

  const response = await fetchApi(
    `Represntative/delivery-range?${params.toString()}`
  );

  return response;
};